import { render, staticRenderFns } from "./RangeType.vue?vue&type=template&id=24deb43c&scoped=true"
import script from "./RangeType.vue?vue&type=script&lang=js"
export * from "./RangeType.vue?vue&type=script&lang=js"
import style0 from "./RangeType.vue?vue&type=style&index=0&id=24deb43c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24deb43c",
  null
  
)

export default component.exports